import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createPlatformMutation } from '../clients';
import { sessionSchema } from '../types';

export type LoginParams = {
	login: string;
	password: string;
};

export const loginMutation = createPlatformMutation({
	params: declareParams<LoginParams>(),
	request: {
		method: 'POST',
		url: '/client-login',
		body: (params) => params,
	},
	response: {
		contract: zodContract(sessionSchema),
	},
});
